import React, { useEffect, useState } from "react";
import { Row, Col, Space } from 'antd';
import { ButtonComponent, SelectWithSearch } from "@comps/components";
import { LeftOutlined } from '@ant-design/icons';
import { NextButton } from '../components';
import { checkPermissions } from '@comps/commonFunctions';

const BasePagination = (props) => {

  const [totalPages, setTotalPages] = useState([])
  const [previousCount, setPreviousCount] = useState(props.pagination ? props.pagination.count : 0);
  const [currentCount, setCurrentCount] = useState(0)
  const [pagination, setPagination] = useState({})
  useEffect(() => {
    setData()
    // eslint-disable-next-line
  }, [props]);

  const setData = () => {
    if (props.pagination !== undefined) {
      const total_pages = props.pagination.total_pages !== undefined ? props.pagination.total_pages : props.pagination.last_page;
      const pages = []
      for (let index = 1; index <= total_pages; index++) {
        pages.push(
          {
            label: 'Page ' + index + ' of ' + total_pages,
            value: index
          }
        )
      }
      setTotalPages(pages)
      if (props.pagination.count !== undefined) {
        setCurrentCount(props.pagination.count === undefined ? props.pagination.to : props.pagination.count); // Store current count
      } else {
        setCurrentCount(props.pagination.from && props.pagination.count === undefined ? props.pagination.from + '-' + props.pagination.to : props.pagination.count); // Store current count
      }
      setPagination(props.pagination)
    }
  }
  // Function to handle pagination and update data
  const handlePageChange = (current, action) => {
    if (action === 'next') {
      setPreviousCount(previousCount + currentCount)
    }
    if (action === 'back') {
      setPreviousCount(previousCount - current)
    }
  };



  return (
    <div className="site-page-wrapper" style={ { marginTop: '0px', marginBottom: '24px' } }>
      <style>{ `
        .modern-pagination-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #ffffff;
          padding: 16px 24px;
          border-radius: 12px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
          border: 1px solid #f0f2f5;
          flex-wrap: wrap;
          gap: 16px;
        }

        .modern-pagination-container .entries-info {
          font-size: 14px;
          color: #64748b;
          font-weight: 500;
        }
        .modern-pagination-container .entries-info strong {
          color: #1e293b;
          font-weight: 800;
        }

        .modern-pagination-container .pagination-actions {
          display: flex;
          align-items: center;
          gap: 24px;
          flex-wrap: wrap;
        }

        /* Redesigning the AntSelect to look like a pill */
        .modern-pagination-container .ant-select-selector {
          border-radius: 20px !important;
          border: 1px solid #e2e8f0 !important;
          background-color: #f8fafc !important;
          color: #475569 !important;
          font-weight: 600;
          box-shadow: none !important;
          transition: all 0.3s ease;
        }
        
        .modern-pagination-container .ant-select:hover .ant-select-selector {
          border-color: #4079FC !important;
        }
        
        .modern-pagination-container .ant-select-arrow {
          color: #94a3b8;
        }

        /* Buttons adjustments */
        .modern-pagination-container .ant-btn {
          border-radius: 8px !important;
          font-weight: 600 !important;
          box-shadow: 0 2px 4px rgba(0,0,0,0.02) !important;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .modern-pagination-container .previous-button,
        .modern-pagination-container .next-button-cls {
           background-color: #ffffff !important;
           color: #475569 !important;
           border: 1px solid #cbd5e1 !important;
        }
        
        .modern-pagination-container .previous-button:hover:not([disabled]),
        .modern-pagination-container .next-button-cls:hover:not([disabled]) {
           border-color: #4079FC !important;
           color: #4079FC !important;
           background-color: #f0f5ff !important;
           transform: translateY(-1px);
        }

        .modern-pagination-container .ant-btn[disabled] {
          background-color: #f8fafc !important;
          border-color: #e2e8f0 !important;
          color: #94a3b8 !important;
          box-shadow: none !important;
        }
      `}</style>

      {
        checkPermissions(props.modkey, 'view') && props.pagination !== undefined &&
        <div className="modern-pagination-container">
          <div className="entries-info">
            Showing <strong>{ currentCount ? currentCount : 0 }</strong> of <strong>{ props.pagination.total }</strong> Entries
          </div>

          <div className="pagination-actions">
            {
              props.numbering !== false ? (
                <div style={ { display: 'flex', alignItems: 'center', gap: '8px' } }>
                  <span style={ { color: '#94a3b8', fontSize: '13px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' } }>Jump to</span>
                  <SelectWithSearch
                    style={ { width: '130px' } }
                    value={ props.currentPage }
                    options={ totalPages }
                    onChange={ (page) => props.setCurrentPage(page) }
                    allowClear={ false }
                  />
                </div>
              ) : null
            }
            <Space size="middle">
              <ButtonComponent className="previous-button" text='Previous'
                onClick={
                  () => {
                    props.setCurrentPage(props.currentPage - 1)
                  }
                }
                disabled={ props.currentPage === 1 } type='default' icon={ <LeftOutlined /> }
              />
              <NextButton className="next-button-cls"
                onClick={ () => {
                  props.setCurrentPage(props.currentPage + 1)
                }
                } disabled={ props.currentPage === totalPages.length || !currentCount } type='default'
              />
            </Space>
          </div>
        </div>
      }
    </div>
  );
};

export default BasePagination;
